import { SET_DASHBOARD_WITH_SESSION, GET_DASHBOARD_WITHOUT_SESSION, SET_DASHBOARD_WITHOUT_SESSION, SET_DASHBOARD_WITH_SESSION_SHIBBOLETH, SET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER, GET_DASHBOARD_EMAIL_VERIFICATION, SET_DASHBOARD_EMAIL_VERIFICATION } from "./action";

const defaultState = {
    __htmlWithSession: "",
    __htmlWithoutSession: "",
    shibbolethStatus:{},
    accountIdentifier:{},
    verifyemailMessage:'',
}
export default function dashboardState(state = defaultState, action) {
    switch (action.type) {
        case GET_DASHBOARD_WITHOUT_SESSION:
            return state
        case SET_DASHBOARD_WITHOUT_SESSION:
            return { ...state, ['__htmlWithoutSession']: action.payload.text };
        case SET_DASHBOARD_WITH_SESSION:
            return { ...state, ['__htmlWithSession']: action.payload.text };
            case SET_DASHBOARD_WITH_SESSION_SHIBBOLETH:
      return {
        ...state,
        shibbolethStatus: action.payload,
      };
      case SET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER:
        return {...state, accountIdentifier: action.payload};
        case SET_DASHBOARD_EMAIL_VERIFICATION:
            return {...state, verifyemailMessage: action.payload}
        default:
            return state;
    }
}